import { Component, OnInit, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { startWith, map } from 'rxjs/operators';
import { AddressService } from '../../services/address/address.service';

@Component({
  selector: 'ark-look-up-location',
  templateUrl: './look-up-location.component.html',
  styleUrls: ['./look-up-location.component.scss']
})
export class LookUpLocationComponent implements OnInit {

  province = JSON.parse(localStorage.getItem('province'));
  city = [];
  barangay = [];
  country = JSON.parse(localStorage.getItem('country'));
  filterlocation: Observable<string[]>;
  selectName:string;
  location = [];
  selectedRow:Number;
  supplier = [];
  loading:boolean = false;

  formGroup: FormGroup;
  label = 'Country';

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<LookUpLocationComponent>,
    public addressService: AddressService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      location:['',null]
    });

    this.searchLocation();

    if (this.data.i == 1) {
    } else if (this.data.i == 2) {
      this.label = 'Province';
    } else if (this.data.i == 3) {
      this.label = 'City';
    } else if (this.data.i == 4) {
      this.label = 'Barangay';
    } else if (this.data.i == 5) {
      this.label = 'Supplier';
      this.loading = true;
      this.addressService.getSupplier().subscribe(result => {
        this.supplier = result;
        this.loading = false;
        this.location = this.supplier;
      });
    } else if (this.data.i == 6) {
      this.label = 'City';
    }
  
  }

  selectedItem(i?:number,name?:string){
    this.selectName = name;
    this.selectedRow = i;
  }

  changeCity(id,i){
    this.addressService.getCity(id).subscribe(res=>{
      this.city = res;
    });
  }

  changeBarangay(id,i){
    this.addressService.getBarangay(id).subscribe(res=>{
      this.barangay = res;
    });
  }

  searchLocation() {
    let filterValue = this.formGroup.controls['location'].value.toLowerCase();
    this.selectName = '';
    if (this.data.i == 1) {
      this.location = this.country.filter(option => option.toLowerCase().includes(filterValue));
    } else if (this.data.i == 2) {
      this.location = this.province.filter(option => option.provDesc.toLowerCase().includes(filterValue));
    } else if (this.data.i == 3) {
      this.location = this.data.city.filter(option => option.citymunDesc.toLowerCase().includes(filterValue));
    } else if (this.data.i == 4) {
      this.location = this.data.barangay.filter(option => option.brgyDesc.toLowerCase().includes(filterValue));
    } else if (this.data.i == 5) {
      this.location = this.supplier.filter(option => option.supplier.toLowerCase().includes(filterValue));
    } else if (this.data.i == 6) {
      this.location = this.data.city.filter(option => option.title.toLowerCase().includes(filterValue));
    }
  }
  
  closeOnClick() {
    this.dialogRef.close('');
  }

  setSelectName(){
    let data = {
      value: this.selectName
    }
    this.dialogRef.close(data);
  }

}
